
import React from 'react';

export default function LocationSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">
            Serving Owings Mills, Maryland
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            U.B.K Window Tint provides professional window tinting services to Owings Mills and the surrounding Baltimore County area. Our mobile service brings premium ceramic tint installation directly to your location.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-2xl font-bold text-secondary mb-4">
              Why Choose Us in Owings Mills?
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Local Expertise:</strong> Serving Owings Mills and Baltimore County with specialized tinting solutions
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-car-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Mobile Service:</strong> We come to your home, office, or anywhere in Owings Mills
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-check-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Lifetime Warranty:</strong> All window tinting services come with a lifetime warranty
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Same Day Service:</strong> Fast, professional installation available in Owings Mills
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-secondary mb-4">
              Owings Mills Service Areas
            </h3>
            <p className="text-gray-700 mb-4">
              We provide professional window tinting services throughout Owings Mills and nearby communities including:
            </p>
            <div className="grid grid-cols-2 gap-3 text-sm text-gray-600">
              <div>• Owings Mills</div>
              <div>• Reisterstown</div>
              <div>• Pikesville</div>
              <div>• Randallstown</div>
              <div>• Garrison</div>
              <div>• Glyndon</div>
              <div>• Lochearn</div>
              <div>• Milford Mill</div>
              <div>• Windsor Mill</div>
              <div>• Woodlawn</div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600 mb-2"><strong>Contact Us:</strong></p>
              <p className="text-lg font-bold text-accent">(443) 800-0348</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
